/*
    模块组件
    ChenYN

    说明
    主页底部切换栏

    版本
    1.0

    传参
        showMenu Boolean : 是否显示当前弹窗
        replyId Number : 回复的id
        contentText String : 内容，为了方便复制
        type String : 回复的类型 reply = 回复评论； replyUser = 回复评论的评论


    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <CommentMenu></CommentMenu>
*/
<template>
    <Popup :show="showMenu" position="bottom" round @click-overlay="closePup" :close-on-popstate="true">
        <template v-for="(v, i) in replyItem" :key="i">
            <div class="bar_item" v-if="v.open" @click="v.fun">
                <img :src="v.icon" :alt="v.txt">
                <span>{{v.txt}}</span>
            </div>
        </template>

        <Button round class="pop_cancel" @click="closePup">取消</Button>
    </Popup>

    <!-- S 回复弹窗 -->
    <comment-popup :show="showCommentPop" @showCommentPopup="showCommentPopup" :type="commentType" :id="commentForumId" :callback="callback" :closePup="closePup"/>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';
import { Button, Popup } from 'vant';
import router from "@/router";
import Util from '@/assets/js/lib/util';
import replyIcon from "@/assets/images/forum/icon_reply.png"
import copyIcon from "@/assets/images/forum/icon_copy.png"
import complaintIcon from "@/assets/images/forum/icon_complaint.png"
import CommentPopup from '@/components/Comment_Popup/Comment_Popup.vue';

export default defineComponent({
    name: 'CommentMenu',
    components: { Button, Popup, CommentPopup},
    emits: ['closeMenu'],
    props: {
        showMenu: {
            type: Boolean,
            default: false
        },
        contentText: {
            type: String,
            default: ''
        },
        replyId: {
            type: Number,
            default: 0
        },
        replyUserId: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: 'reply'
        },
        callback: {
            type: Function
        }
    },
    setup(props, { emit }) {
        const state = reactive({
            replyItem: [
                {
                    icon: replyIcon, //图标
                    txt: '回复', //文案
                    fun: () => methods.replyComment(), //事件
                    open: true, //是否开放展示
                },
                {
                    icon: copyIcon, //图标
                    txt: '复制', //文案
                    fun: () => methods.copyText(), //事件
                    open: true, //是否开放展示
                },
                {
                    icon: complaintIcon, //图标
                    txt: '举报', //文案
                    fun: () => methods.complaintGolink( ), //事件
                    open: true, //是否开放展示
                },
            ],
            util: new Util(),

            showCommentPop: false, //评论的弹窗
            commentType: '',//评论的类型
            commentForumId:'',//评论的id
            callback: props.callback,
        });
        const data = reactive({});
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
            replyComment: (id = props.replyId) => {
                if(props.type == 'reply') {
                    state.commentType = props.type
                    state.commentForumId = props.replyId
                    state.showCommentPop = true
                }
                if(props.type == 'replyUser') {
                    console.log(123456)
                    console.log('回复楼中楼', props.replyUserId)
                    state.commentType = props.type
                    state.commentForumId = props.replyUserId
                    state.showCommentPop = true
                }
            },
            copyText: () => { //复制信息
                if(state.util.copyText(props.contentText)){
                    window.Components.toast('复制成功');
                }
                methods.closePup();
            },
            closePup: () => {
                emit('closeMenu')
            },
            complaintGolink: () => {
                methods.closePup();
                methods.goState({
                    name: 'complaint',
                    params: {
                        type: props.type,
                        id: props.replyId
                    }
                })
            },
            showCommentPopup: (val) => {
                state.showCommentPop = val
            },
        }; //需要对外暴露的方法

        onMounted(() => {
        //   console.log("组件渲染");
        });

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./CommentMenu.less";
</style>
